var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.666 0C13.6513 0 0.666016 12.9853 0.666016 29C0.666016 45.0147 13.6513 58 29.666 58C45.6807 58 58.666 45.0147 58.666 29C58.666 12.9853 45.6807 0 29.666 0ZM38.9939 29.4467L24.8564 39.7326C24.7789 39.7883 24.6876 39.8215 24.5924 39.8287C24.4972 39.8358 24.4019 39.8166 24.3169 39.7731C24.232 39.7296 24.1607 39.6636 24.1108 39.5822C24.0609 39.5008 24.0345 39.4073 24.0343 39.3118V18.7529C24.034 18.6573 24.0602 18.5634 24.1099 18.4817C24.1597 18.4001 24.2311 18.3338 24.3162 18.2902C24.4014 18.2466 24.4969 18.2275 24.5922 18.2349C24.6876 18.2423 24.779 18.276 24.8564 18.3321L38.9939 28.6116C39.0607 28.6588 39.1152 28.7214 39.1528 28.7941C39.1904 28.8667 39.21 28.9473 39.21 29.0291C39.21 29.1109 39.1904 29.1915 39.1528 29.2642C39.1152 29.3368 39.0607 29.3994 38.9939 29.4467Z",
    fill: "#141140"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.f4bf6248197e4479dc93312e2be9b8c7.svg";
export { ForwardRef as ReactComponent };